import React, { useEffect, useState } from "react";
import "./Outwards.css";

const Outwards = () => {

    const [outwards, setOutwards] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showForm, setShowForm] = useState(false);

    // ============================================================
    // GET LOGGED-IN USER GMAIL
    // ============================================================

    const userEmail = sessionStorage.getItem("userEmail");

    // ============================================================
    // TODAY'S DATE
    // ============================================================

    const today = new Date().toISOString().split("T")[0];

    // ============================================================
    // FORM DATA
    // ============================================================

    const [formData, setFormData] = useState({
        item: "",
        date: today,
        outwards: ""
    });

    // ============================================================
    // GET OUTWARDS
    // ============================================================

    const fetchOutwards = async () => {

        if (!userEmail) {
            console.error("User Gmail not found in sessionStorage");
            setLoading(false);
            return;
        }

        try {

            setLoading(true);

            const response = await fetch(
                `/outwards/${encodeURIComponent(userEmail)}`
            );

            if (!response.ok) {
                throw new Error(
                    `HTTP error: ${response.status}`
                );
            }

            const data = await response.json();

            console.log("Outwards data:", data);

            setOutwards(Array.isArray(data) ? data : []);

        } catch (error) {

            console.error(
                "Error fetching outwards:",
                error
            );

            setOutwards([]);

        } finally {

            setLoading(false);

        }
    };

    // ============================================================
    // LOAD OUTWARDS
    // ============================================================

    useEffect(() => {

        fetchOutwards();

    }, [userEmail]);

    // ============================================================
    // HANDLE INPUT
    // ============================================================

    const handleChange = (e) => {

        const { name, value } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

    };

    // ============================================================
    // ADD OUTWARDS
    // ============================================================

    const handleSubmit = async (e) => {

        e.preventDefault();

        if (!userEmail) {

            alert(
                "User Gmail not found. Please login again."
            );

            return;
        }

        if (!formData.item.trim()) {

            alert("Please enter the item.");

            return;
        }

        if (
            formData.outwards === "" ||
            Number(formData.outwards) <= 0
        ) {

            alert(
                "Outwards quantity must be greater than 0."
            );

            return;
        }

        try {

            const quantity = Number(formData.outwards);

            console.log("Sending Outwards:", {
                gmail: userEmail,
                item: formData.item,
                date: formData.date,
                outwards: quantity
            });

            const response = await fetch(
                "/outwards",
                {
                    method: "POST",

                    headers: {
                        "Content-Type": "application/json"
                    },

                    body: JSON.stringify({
                        gmail: userEmail,
                        item: formData.item.trim(),
                        date: formData.date,
                        outwards: quantity
                    })
                }
            );

            const result = await response.json();

            console.log(
                "Outwards API response:",
                result
            );

            if (!response.ok) {

                throw new Error(
                    result.message ||
                    "Failed to add outwards"
                );

            }

            alert(
                "Outwards added successfully"
            );

            // ====================================================
            // RESET FORM
            // ====================================================

            setFormData({
                item: "",
                date: today,
                outwards: ""
            });

            // ====================================================
            // CLOSE FORM
            // ====================================================

            setShowForm(false);

            // ====================================================
            // REFRESH TABLE
            // ====================================================

            await fetchOutwards();

        } catch (error) {

            console.error(
                "Error adding outwards:",
                error
            );

            alert(error.message);

        }

    };

    // ============================================================
    // DELETE OUTWARDS
    // ============================================================

    const deleteOutwards = async (inventoryId) => {

        if (!userEmail) {

            alert(
                "User Gmail not found. Please login again."
            );

            return;
        }

        const confirmDelete = window.confirm(
            "Are you sure you want to delete this outwards record?"
        );

        if (!confirmDelete) {
            return;
        }

        try {

            const response = await fetch(
                `/outwards/${inventoryId}?gmail=${encodeURIComponent(
                    userEmail
                )}`,
                {
                    method: "DELETE"
                }
            );

            const result = await response.json();

            if (!response.ok) {

                throw new Error(
                    result.message ||
                    "Delete failed"
                );

            }

            alert(
                "Outwards deleted successfully"
            );

            await fetchOutwards();

        } catch (error) {

            console.error(error);

            alert(error.message);

        }

    };

    // ============================================================
    // UI
    // ============================================================

    return (

        <div className="outwards-page">

            {/* ====================================================
                HEADER
            ==================================================== */}

            <div className="outwards-header">

                <div>
                    <h1>Outwards</h1>

                    <p>
                        Track outgoing inventory
                    </p>
                </div>

                <button
                    className="add-outwards-btn"
                    onClick={() =>
                        setShowForm(!showForm)
                    }
                >
                    {showForm
                        ? "? Close"
                        : "+ Add Outwards"
                    }
                </button>

            </div>


            {/* ====================================================
                ADD OUTWARDS FORM
            ==================================================== */}

            {showForm && (

                <div className="outwards-form-card">

                    <h2>Add Outwards</h2>

                    <form onSubmit={handleSubmit}>

                        <div className="outwards-form-grid">

                            {/* Gmail */}

                            <div className="form-group">

                                <label>
                                    Gmail
                                </label>

                                <input
                                    type="text"
                                    value={userEmail || ""}
                                    disabled
                                    className="readonly-input"
                                />

                            </div>


                            {/* Item */}

                            <div className="form-group">

                                <label>
                                    Item
                                </label>

                                <input
                                    type="text"
                                    name="item"
                                    placeholder="Enter item"
                                    value={formData.item}
                                    onChange={handleChange}
                                    required
                                />

                            </div>


                            {/* Date */}

                            <div className="form-group">

                                <label>
                                    Date
                                </label>

                                <input
                                    type="date"
                                    name="date"
                                    value={formData.date}
                                    onChange={handleChange}
                                    required
                                />

                            </div>


                            {/* Outwards */}

                            <div className="form-group">

                                <label>
                                    Outwards Quantity
                                </label>

                                <input
                                    type="number"
                                    name="outwards"
                                    placeholder="Enter quantity"
                                    min="1"
                                    step="0.01"
                                    value={formData.outwards}
                                    onChange={handleChange}
                                    required
                                />

                            </div>

                        </div>


                        {/* FORM ACTIONS */}

                        <div className="form-actions">

                            <button
                                type="button"
                                className="cancel-btn"
                                onClick={() => {
                                    setShowForm(false);

                                    setFormData({
                                        item: "",
                                        date: today,
                                        outwards: ""
                                    });
                                }}
                            >
                                Cancel
                            </button>

                            <button
                                type="submit"
                                className="save-outwards-btn"
                            >
                                Save Outwards
                            </button>

                        </div>

                    </form>

                </div>

            )}


            {/* ====================================================
                TABLE
            ==================================================== */}

            <div className="outwards-table-card">

                <div className="table-wrapper">

                    {loading ? (

                        <div className="empty-outwards">
                            <p>
                                Loading outwards...
                            </p>
                        </div>

                    ) : outwards.length === 0 ? (

                        <div className="empty-outwards">

                            <div className="empty-icon">
                                ??
                            </div>

                            <h3>
                                No Outwards Records
                            </h3>

                            <p>
                                Add an outwards entry to see it here.
                            </p>

                        </div>

                    ) : (

                        <table>

                            <thead>

                                <tr>

                                    <th>ID</th>
                                    <th>Gmail</th>
                                    <th>Vendor</th>
                                    <th>GST Number</th>
                                    <th>Item</th>
                                    <th>Date</th>
                                    <th>Outwards</th>
                                    <th>Action</th>

                                </tr>

                            </thead>


                            <tbody>

                                {outwards.map((row) => (

                                    <tr
                                        key={row.inventory_id}
                                    >

                                        <td>
                                            {row.inventory_id}
                                        </td>

                                        <td>
                                            {row.gmail}
                                        </td>

                                        <td>
                                            {row.vendor_name}
                                        </td>

                                        <td>
                                            {row.gst_number}
                                        </td>

                                        <td>
                                            {row.item}
                                        </td>

                                        <td>
                                            {row.date}
                                        </td>

                                        <td className="outwards-quantity">
                                            {row.outwards}
                                        </td>

                                        <td>

                                            <button
                                                className="delete-outwards-btn"
                                                onClick={() =>
                                                    deleteOutwards(
                                                        row.inventory_id
                                                    )
                                                }
                                            >
                                                Delete
                                            </button>

                                        </td>

                                    </tr>

                                ))}

                            </tbody>

                        </table>

                    )}

                </div>

            </div>

        </div>

    );

};

export default Outwards;

